import React from 'react';
import styled, { css, keyframes } from 'styled-components';

interface Props {
  size: 'small' | 'medium' | 'full';
}

const pulse = keyframes`
  0% {
    oacity: 1;
  }
  50% {
    opacity: .5;
  }
  100% {
    oacity: 1;
  }
`;

const StyledTextPlaceholder = styled.div<{ readonly size: string }>`
  height: 20px;
  background: rgba(220, 220, 220.2);
  border-radius: 8px;
  animation: ${pulse} 2s 0s infinite;

  ${({ size }) => {
    switch (size) {
      case 'full':
        return css`
          width: 100%;
        `;
      case 'medium':
        return css`
          width: 50%;
        `;
      case 'small':
        return css`
          width: 30%;
        `;
      default:
        return css`
          width: 50%;
        `;
    }
  }}
`;

const StyledBlockPlaceholder = styled.div<{ readonly size: string }>`
  background: rgba(220, 220, 220.2);
  border-radius: 8px;
  animation: ${pulse} 2s 0s infinite;

  ${({ size }) => {
    switch (size) {
      case 'full':
        return css`
          width: 250px;
          height: 180px;
        `;
      case 'medium':
        return css`
          width: 220px;
          height: 150px;
        `;
      case 'small':
        return css`
          width: 140px;
          height: 100px;
        `;
      default:
        return css`
          width: 140px;
          height: 100px;
        `;
    }
  }}
`;

export const TextPlaceholder = ({ size }: Props) => {
  return <StyledTextPlaceholder size={size} />;
};

export const BlockPlaceholder = ({ size }: Props) => {
  return <StyledBlockPlaceholder size={size} />;
};
